module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"Show More":"Show More","Show Less":"Show Less"},"ja":{"Show More":"詳細表示","Show Less":"詳細閉じる"}}')
  delete Component.options._Ctor
}
